import React from "react";
import Logo from "../Img/bannerLogo.svg";
import { useSelector, useDispatch } from "react-redux";
import { clearUser } from "../features/userSlice";
import { useNavigate, Link } from "react-router-dom";

const C_Navbar = () => {
  const user = useSelector((state) => state.user.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(clearUser()); // 清空 Redux
    localStorage.clear(); // 清空所有 localStorage
    navigate("/"); // 回到登入頁
  };

  return (
    <div className="navbar">
      <div className="navbar-left">
        <img src={Logo} alt="旌旗 Logo" className="navbar-logo" />
        <h2 className="navbar-title">旌旗新系統 Email 驗證回傳網址</h2>
      </div>

      {user && (
        <div className="navbar-user">
          👤{user.email}
          {/* <Link to="/searchEmail" className="navbar-link">
            查詢帳號
          </Link> */}
          <button className="logout-btn" onClick={handleLogout}>
            登出
          </button>
        </div>
      )}
    </div>
  );
};

export default C_Navbar;
